import { useBoolean, useToast } from '@chakra-ui/react'
import fileDownload from 'js-file-download'
import {
  createContext,
  FC,
  useCallback,
  useMemo,
  useRef,
  useState
} from 'react'
import CsvDownloader from 'react-csv-downloader'
import { AiOutlineBarChart } from 'react-icons/ai'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'

import useFilters from '@hook/shared/use-filters'
import useSessions from '@hook/shared/use-sessions'

import { actionsHeaderKpi } from '@helper/kpi/storage/actionsHeaderKpi'
import { formatParamsModalKpiToSend } from '@helper/kpi/storage/formatParamsModalKpiToSend'
import { paramsToSendMapping } from '@helper/kpi/storage/paramsToSendMapping'
import { parseStorageKpiData } from '@helper/kpi/storage/parseStorageKpiData'
import { parseStorageKpiDataModal } from '@helper/kpi/storage/parseStorageKpiDataModal'
import { parseStorageKpiExportData } from '@helper/kpi/storage/parseStorageKpiExportData'
import { validateGroupName } from '@helper/kpi/storage/validateGroupName'
import { validateIfShowColumnInTable } from '@helper/kpi/storage/validateIfShowColumnInTable'
import {
  decrypterHeaderStorange,
  encrypteHeaderStorange
} from '@helper/util/cryptoStorange'
import generic from '@service/generic'
import kpi from '@service/kpi'

import { ILayoutFilter } from '@base/@types/components/Layout/Filters'
import {
  ITableGridAction,
  ITableHeader
} from '@base/@types/components/Layout/TableGrid'
import { ILayoutToolsAction } from '@base/@types/components/Layout/Tools'
import {
  IkpiModalTableStructure,
  IKpiStorageContext,
  ILineParams,
  IParamsToSend,
  IParseParamsModalOrGraphic,
  IUpdateParams,
  Pagination
} from '@base/@types/providers/Kpi/StorageProvider'
import { stotageFieldsFilter } from '@base/variables/headers/kpi/storage/storageFieldsFilter'
import { storageIndicatorsRequest } from '@base/variables/headers/kpi/storage/storageIndicatorsRequest'
import { kpiStorageHeader } from '@base/variables/headers/kpi/storage/storageKpiHeader'
import { storageKpiModalTableStructure } from '@base/variables/headers/kpi/storage/storageKpiModalTableStructure'

const KpiStorageProvider: FC = ({ children }) => {
  const toast = useToast()
  const { register } = useSessions()
  const [disabledDownload, setDisabledDownload] = useState(false)
  const filtersList: ILayoutFilter[] = stotageFieldsFilter
  const csvDownload = useRef(null)
  const [query, setQuery] = useState('')
  const [defaoutAverageSale, setDefaoutAverageSale] = useState(120)
  const [isModalConfig, setIsModalConfig] = useState(false)
  const [isModal, setIsModal] = useState(false)
  const [filters, setFilters] = useBoolean(true)
  const [loading, setLoading] = useState(false)
  const [isGraphic, setIsGraphic] = useState(false)
  const [isShowContentChart, setIsShowContentChart] = useState(false)
  const [daysQuantity, setDaysQuantity] = useState(120)
  const [graphicValues, setGraphicValues] = useState({} as any[])
  const [loadingModal, setLoadingModal] = useState(false)
  const [loadingGraphic, setLoadingGraphic] = useState(false)
  const [isLoadingExport, setIsLoadingExport] = useState(false)
  const [selected, setSelected] = useState(false)
  const [stateLineData, setStateLineData] = useState({} as ILineParams)
  const [fetching, _setFetching] = useState(false)
  const [producFilter, setProductFilter] = useImmer<any>([])
  const [filename, setFilename] = useState('KPI Estoque')
  const [dataNew] = useImmer<any[]>([])
  const { data: dataFilter } = useFilters()
  const [data, updateData] = useImmer<any[]>([])
  const [modalData, updateModalData] = useImmer<any[]>([])
  const [params, updateParams] = useImmer<any>(storageIndicatorsRequest)
  const [headers, updateHeaders] = useImmer<ITableHeader[]>(kpiStorageHeader)
  const [paramsModalToSend, setParamsModalToSend] = useState<IParamsToSend>()
  const [modalHeaders, updateModalHeaders] = useState<
    IkpiModalTableStructure[]
  >(storageKpiModalTableStructure)

  const [, setParamsGraphicToSend] = useState<IParamsToSend>()

  const [paramsToSend, setParamsToSend] = useState<IParamsToSend>(() => {
    const paramsFormatted = { ...storageIndicatorsRequest }

    return paramsFormatted
  })

  const [pagination, updatePagination] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })

  const [paginationMain, updatePaginationMain] = useImmer<Pagination>({
    actualPage: 0,
    rows: 0,
    totalPages: 0,
    totalRows: 0,
    skip: 0
  })

  const updateIsModalConfig = () => {
    setIsModalConfig(!isModalConfig)
  }

  const getDataGraphic = useCallback(
    (paramsToSendFormatted: IParamsToSend) => {
      setIsShowContentChart(true)
      setLoadingGraphic(false)
      getMaintence()

      kpi
        .postStorageIndicatorGraphicData(paramsToSendFormatted || paramsToSend)
        .then(({ data: { data } }) => {
          setGraphicValues(data)
          setDaysQuantity(paramsToSend.periodoVendaMedia)
          setLoadingGraphic(false)
          setIsGraphic(false)
        })
        .catch(_ex => {
          setIsGraphic(false)
          setLoadingGraphic(false)
          setIsShowContentChart(false)
          setGraphicValues([])
          const isData = 'Nenhum dado encontrado'

          toast({
            title: 'Dados não encontrados.',
            description: 'Não há dados para que possa ser montado o gráfico',
            status: isData ? 'info' : 'error',
            duration: 4000,
            isClosable: true,
            position: 'top-right'
          })
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paramsToSend, toast]
  )

  const handlePageChange = useCallback(
    async (page: number, paramsToSendFormatted?: IParamsToSend) => {
      setLoadingModal(true)
      let params = {}
      const idsProducr = producFilter.map((x: any) => x.value)
      if (paramsToSendFormatted) {
        params = {
          ...paramsToSendFormatted,
          produtoIds: idsProducr
        }
      } else {
        params = {
          ...paramsModalToSend,
          produtoIds: idsProducr
        }
      }
      kpi
        .getStorageIndicatorProductsData(params, page)
        .then(({ data: { data, pagination } }) => {
          updatePagination(pagination)
          setIsModal(true)
          updateModalData(data)
          setLoadingModal(false)
        })
        .catch(() => setLoadingModal(false))
    },
    [paramsModalToSend, producFilter, updateModalData, updatePagination]
  )

  const getDataModal = useCallback(
    (paramsToSendFormatted: IParamsToSend) => {
      setParamsGraphicToSend(paramsToSendFormatted)
      setParamsModalToSend(paramsToSendFormatted)
      handlePageChange(1, paramsToSendFormatted)
    },
    [handlePageChange]
  )

  const parseParamsModalOrGraphic = ({
    isClickLine,
    lineData
  }: IParseParamsModalOrGraphic) => {
    if (localStorage.getItem('@kpiStorageParamsToSend:')) {
      const paramsToSendSaved = JSON.parse(
        localStorage.getItem('@kpiStorageParamsToSend:')
      )

      const paramsToSendFormatted = formatParamsModalKpiToSend(
        lineData || stateLineData,
        paramsToSendSaved || paramsToSend
      )

      if (!isClickLine) {
        return getDataModal(paramsToSendFormatted)
      }

      getDataGraphic(paramsToSendFormatted)
    }
  }

  const updateIsGraphic = (lineData: ILineParams) => {
    setIsGraphic(false)
    setStateLineData(lineData)
    parseParamsModalOrGraphic({
      isClickLine: true,
      lineData
    })
  }

  const updateIsGraphicFirst = () => {
    setIsGraphic(false)
    const paramsToSendFormatted = formatParamsModalKpiToSend(
      stateLineData,
      paramsToSend
    )

    getDataGraphic(paramsToSendFormatted)
  }

  const handleSelected = (lineData: ILineParams) => {
    setSelected(!!lineData)
    setStateLineData(lineData)
    setLoadingModal(true)

    if (lineData) {
      parseParamsModalOrGraphic({
        isClickLine: false,
        lineData
      })
    }
  }

  const tableInteraction = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'icon',
        icon: <AiOutlineBarChart />,
        onSelect: handleSelected
      }
    ]
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const tableInteractionModal = useMemo<ITableGridAction[]>(() => {
    return [
      {
        type: 'icon',
        onFocus: true,
        icon: <AiOutlineBarChart />,
        onSelect: () => []
      }
    ]
  }, [])

  const handleStorange = useCallback(async () => {
    if (localStorage.getItem('@kpiStorageColumnsTable:')) {
      const newHeader = decrypterHeaderStorange('@kpiStorageColumnsTable:')

      updateHeaders(newHeader)
    }
  }, [updateHeaders])

  const handleHeaderLocalStorange = useCallback(() => {
    if (!localStorage.getItem('@kpiStorageColumnsTable:')) {
      encrypteHeaderStorange('@kpiStorageColumnsTable:', headers)
    } else {
      localStorage.removeItem('@kpiStorageColumnsTable:')
      encrypteHeaderStorange('@kpiStorageColumnsTable:', headers)
    }
  }, [headers])

  const updateModalColumnsAndSaveState = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...modalHeaders]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show
      }

      updateModalHeaders(newHeaders)
    },
    [modalHeaders]
  )

  const toggleColumn = useCallback(
    (index: number, column: number) => {
      const newHeaders = [...headers]

      newHeaders[index].columns[column] = {
        id: newHeaders[index].columns[column].id,
        name: newHeaders[index].columns[column].name,
        show: !newHeaders[index].columns[column].show,
        notShowColumn: newHeaders[index].columns[column].notShowColumn
          ? !newHeaders[index].columns[column].notShowColumn
          : true
      }

      updateHeaders(newHeaders)
      handleHeaderLocalStorange()
    },
    [handleHeaderLocalStorange, headers, updateHeaders]
  )

  const actions = useMemo<ILayoutToolsAction[]>(() => {
    return actionsHeaderKpi({
      data,
      headers,
      toggleColumn,
      parseStorageKpiData
    })
  }, [toggleColumn, data, headers])

  const updateShowTableInTable = (data: any[]) => {
    updateData(draft => {
      return draft.filter(item => item.status === 99).concat(data)
    })

    const headersFormatted = validateIfShowColumnInTable(headers, paramsToSend)

    handleStorange()
    updateHeaders(headersFormatted)
  }

  const clearAllFilters = () => {
    const paramsFormatted = { ...storageIndicatorsRequest }

    updateParams({
      ...params,
      empresaIds: false,
      empresaSelectIds: [],
      tipoCentroIds: false,
      tipoCentroSelectIds: [],
      centroCdLojaIds: false,
      centroCdLojaSelectIds: [],
      gerenteCategoriaIds: false,
      gerenteCategoriaSelectIds: [],
      gerenteProdutoIds: false,
      gerenteProdutoSelectIds: [],
      mundoIds: false,
      mundoSelectIds: [],
      categoriaCompactaIds: false,
      categoriaCompactaSelectIds: [],
      categoriaIds: false,
      categoriaSelectIds: [],
      statusIds: false,
      statusSelectIds: [],
      curvaAbcIds: false,
      curvaAbcSelectIds: [],
      depositoIds: false,
      depositoSelectIds: [],
      fornecedorIds: false,
      fornecedorSelectIds: [],
      CMVouEstoque: null,
      closingBase: null
    })

    setDefaoutAverageSale(120)

    setParamsToSend(paramsFormatted)
    if (localStorage.getItem('kpiStorangeParams')) {
      localStorage.setItem(
        'kpiStorangeParams',
        JSON.stringify({
          ...params,
          empresaIds: false,
          empresaSelectIds: [],
          tipoCentroIds: false,
          tipoCentroSelectIds: [],
          centroCdLojaIds: false,
          centroCdLojaSelectIds: [],
          gerenteCategoriaIds: false,
          gerenteCategoriaSelectIds: [],
          gerenteProdutoIds: false,
          gerenteProdutoSelectIds: [],
          mundoIds: false,
          mundoSelectIds: [],
          categoriaCompactaIds: false,
          categoriaCompactaSelectIds: [],
          categoriaIds: false,
          categoriaSelectIds: [],
          statusIds: false,
          statusSelectIds: [],
          curvaAbcIds: false,
          curvaAbcSelectIds: [],
          depositoIds: false,
          depositoSelectIds: [],
          fornecedorIds: false,
          fornecedorSelectIds: [],
          CMVouEstoque: null
        })
      )
    }
    if (localStorage.getItem('kpiStorangeParamsRequest')) {
      localStorage.setItem(
        'kpiStorangeParamsRequest',
        JSON.stringify(paramsFormatted)
      )
    }
  }

  const handleUpdateParams = ({ name, value }: IUpdateParams) => {
    updateParams((draft: { [x: string]: string }) => {
      draft[name] = value
    })
    name === 'vendaMediaIds' && setDefaoutAverageSale(value)

    const paramsToSendFormatted = paramsToSendMapping({
      name,
      value,
      compareName: name,
      paramsToSend,
      fieldName: validateGroupName(name)
    })
    setParamsToSend(paramsToSendFormatted)
    if (localStorage.getItem('kpiStorangeParams')) {
      const newParams: IParamsToSend[] = JSON.parse(
        localStorage.getItem('kpiStorangeParams') || ''
      )

      localStorage.setItem(
        'kpiStorangeParams',
        JSON.stringify({ ...newParams, [name]: value })
      )
    }
    if (localStorage.getItem('kpiStorangeParamsRequest')) {
      localStorage.setItem(
        'kpiStorangeParamsRequest',
        JSON.stringify(paramsToSendFormatted)
      )
    }
  }

  const handleLocalParams = useCallback(async () => {
    if (localStorage.getItem('kpiStorangeParams')) {
      const newParams = JSON.parse(
        localStorage.getItem('kpiStorangeParams') || ''
      )
      newParams.closingBase = null
      updateParams(newParams)
    } else {
      localStorage.setItem('kpiStorangeParams', JSON.stringify(params))
    }
    if (localStorage.getItem('kpiStorangeParamsRequest')) {
      const newParams = JSON.parse(
        localStorage.getItem('kpiStorangeParamsRequest') || ''
      )
      newParams.closingBase = null
      newParams.periodo = null

      setParamsToSend(newParams)
    } else {
      localStorage.setItem(
        'kpiStorangeParamsRequest',
        JSON.stringify(paramsToSend)
      )
    }
  }, [updateParams, setParamsToSend, params, paramsToSend])

  function convertDateFormat(dateStr: string): string {
    const [day, month, year] = dateStr.split('/')
    return `${year}-${month}-${day}`
  }

  const handlePageChangeMain = useCallback(
    async (_page: number) => {
      setLoading(true)

      localStorage.setItem(
        '@kpiStorangeParamsRequest:',
        JSON.stringify(paramsToSend)
      )
      let newParams = {}
      if (localStorage.getItem('kpiStorangeParamsRequest')) {
        newParams = JSON.parse(
          localStorage.getItem('kpiStorangeParamsRequest') || ''
        )
      } else {
        newParams = paramsToSend
      }
      kpi
        .getStorageIndicatorsData(newParams, _page)
        .then(({ data: { data, pagination } }) => {
          updateData(draft => {
            return draft.filter(item => item.status === 99).concat(data)
          })
          updatePaginationMain(pagination)
          setLoading(false)
        })
        .catch(() => {
          updateData([])
          setLoading(false)
        })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [paramsToSend, updateData, updatePagination]
  )
  const getData = useCallback(() => {
    setGraphicValues([])
    setIsShowContentChart(false)
    setIsGraphic(false)
    setLoading(true)
    if (dataFilter.closingBase.length === 0) {
      toast({
        title: 'Atenção.',
        description: 'Aguarda os Filtros serem carregadosl',
        status: 'warning',
        duration: 3000,
        isClosable: true
      })
      setLoading(false)
      return
    }
    if (paramsToSend.periodo === null) {
      handleUpdateParams({
        name: 'closingBase',
        value: {
          value: dataFilter.closingBase[0].value,
          label: dataFilter.closingBase[0].value
        }
      })
    }
    let newParams = {}
    if (localStorage.getItem('kpiStorangeParamsRequest')) {
      newParams = JSON.parse(
        localStorage.getItem('kpiStorangeParamsRequest') || ''
      )
    } else {
      newParams = paramsToSend
    }

    if (paramsToSend.periodo === null) {
      const paramsGraph = paramsToSend
      paramsGraph.periodo = convertDateFormat(
        dataFilter.closingBase[0].value.toString()
      )
      localStorage.setItem(
        '@kpiStorageParamsToSend:',
        JSON.stringify(paramsGraph)
      )
    } else {
      localStorage.setItem(
        '@kpiStorageParamsToSend:',
        JSON.stringify(paramsToSend)
      )
    }

    kpi
      .getStorageIndicatorsData(newParams, 1)
      .then(({ data: { data, pagination } }) => {
        updateShowTableInTable(data)
        updatePaginationMain(pagination)

        localStorage.setItem('@kpiStorageParamsResponse:', JSON.stringify(data))

        register({
          name: 'KPI Estoque',
          path: '/kpi/Estoque',
          loading: false
        })
        setFilters.toggle()
        setLoading(false)
        updateIsGraphicFirst()
      })
      .catch(() => {
        updateData([])
        setLoading(false)
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramsToSend, register, updateData])

  const exportKpiData = useCallback(() => {
    Swal.fire({
      title: 'Exporta dados!',
      html: 'Aguarde um momento<b></b>.',
      timerProgressBar: true,
      timer: 99999,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    const paramsToSendFormatted = parseStorageKpiExportData(
      headers,
      paramsToSend
    )

    kpi
      .postStorageIndicatorExportData(paramsToSendFormatted)
      .then(({ data }) => {
        fileDownload(data, filename + '.csv')
        Swal.close()
      })
      .catch(({ response: { data } }) => {
        const message =
          data.response?.status === 400
            ? data.response?.data?.data[0].message
            : 'Ocorreu um problema interno. Tente novamente mais tarde'
        toast({
          title: 'Atenção.',
          description: message,
          status: 'warning',
          duration: 3000,
          isClosable: true
        })
      })
  }, [filename, headers, paramsToSend, toast])

  const columns = useMemo(() => {
    const data: any[] = []

    for (const header of modalHeaders!) {
      if (!header.columns) continue

      for (const column of header.columns) {
        if (column.show) {
          data.push({
            id: column.id,
            displayName: `${header.group} - ${column.name}`
          })
        }
      }
    }

    return data
  }, [modalHeaders])

  const rows = useMemo(() => {
    const parsedData = parseStorageKpiDataModal(dataNew)

    const body = []

    for (const row of parsedData) {
      const item: any = {}

      for (const column of columns) {
        if (column.id === 'parametros-emax') {
          if (row[column.id].includes('.')) {
            item[column.id] = Number(row[column.id].replace('.', ''))
          } else {
            item[column.id] = Number(row[column.id])
          }
        } else {
          item[column.id] = row[column.id]
        }
      }

      body.push(item)
    }

    return body
  }, [columns, dataNew])

  const exportKpiDataModal = useCallback(() => {
    setIsLoadingExport(true)

    const idsProducr = producFilter.map((x: any) => x.value)
    const params = {
      ...paramsModalToSend,
      produtoIds: idsProducr
    }
    kpi
      .postStorageIndicatorExportDataModal(params)
      .then(({ data }) => {
        setIsLoadingExport(false)
        setDisabledDownload(true)

        fileDownload(data, filename + 'Produtos.csv')

        Swal.close()
      })
      .catch(() => {
        setIsLoadingExport(false)
        setDisabledDownload(true)
      })
  }, [filename, paramsModalToSend, producFilter])

  const getMaintence = useCallback(async () => {
    generic
      .getMaintence('manutencao')
      .then(({ data: { data } }) => {
        if (data.valor === 'true') {
          return (window.location.href = '/manutencao')
        }
      })
      .catch(() => {})
  }, [])

  return (
    <KpiStorageContext.Provider
      value={{
        data: parseStorageKpiData(data),
        query,
        params,
        isModal,
        headers,
        actions,
        filters,
        loading,
        selected,
        filename,
        fetching,
        filtersList,
        tableInteraction,
        defaoutAverageSale,
        getData,
        setQuery,
        setFilters,
        setFilename,
        exportKpiData,
        clearAllFilters,
        updateIsGraphic,
        exportKpiDataModal,
        handleUpdateParams,
        updateIsModalConfig,
        handleLocalParams,

        loadingModal,
        isModalConfig,
        isLoadingExport,
        isModalOpen: selected,
        headersModal: modalHeaders,
        actionsModal: tableInteractionModal,
        kpiModalTableStructure: modalHeaders,
        dataModal: parseStorageKpiDataModal(modalData),
        onModalClose: () => setSelected(!selected),
        onModalChange: updateModalColumnsAndSaveState,

        pagination,
        paginationMain,
        handlePageChange,
        handlePageChangeMain,

        isGraphic,
        daysQuantity,
        graphicValues,
        loadingGraphic,
        isShowContentChart,
        setIsGraphic,
        paramsModalToSend,
        producFilter,
        setProductFilter
      }}
    >
      {children}
      {disabledDownload && (
        <CsvDownloader
          filename={'Kpi-Estoque Produtos'}
          columns={columns}
          datas={rows}
          ref={csvDownload}
          separator=";"
          wrapColumnChar='"'
          bom={true}
        ></CsvDownloader>
      )}
    </KpiStorageContext.Provider>
  )
}

export default KpiStorageProvider
export const KpiStorageContext = createContext<IKpiStorageContext>(
  {} as IKpiStorageContext
)
